import React from "react";
import { Link } from "react-router-dom";
import pageHeaderBg from "../assets/images/page-header-bg.jpg";

function About() {
  return (
    <div className="about-page">
      {/* Page Header Section */}
      <section
        className="page-header parallaxie"
        style={{ backgroundImage: `url(${pageHeaderBg})` }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-2" data-cursor="-opaque">
                  About us
                </h1>
                <nav className="wow fadeInUp">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/">home</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      about us
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Us Section */}
      <div className="about-us page-about-us">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 order-lg-1 order-2">
              <div className="about-us-image">
                <figure className="image-anime reveal">
                  <img
                    src="/hellotruck-web-images/about-image.jpg"
                    alt="About Hello Truck"
                  />
                </figure>
              </div>
            </div>

            <div className="col-lg-6 order-lg-2 order-1">
              <div className="about-us-content">
                <div className="section-title">
                  <h3 className="wow fadeInUp">About us</h3>
                  <h2 className="text-anime-style-2" data-cursor="-opaque">
                    Welcome to <span>Hello Truck </span>, Coimbatore's trusted
                    partner in seamless truck booking & transportation.
                  </h2>
                  <p className="wow fadeInUp" data-wow-delay="0.2s">
                    We, <b>Covai Hello Truck Private Limited (HelloTruck)</b>,
                    are based in Coimbatore and serve Tiruppur and across Tamil
                    Nadu. We are a team of logistics enthusiasts, tech
                    innovators, and customer-centric professionals dedicated to
                    revolutionizing the trucking industry. We specialize in mini
                    truck booking and goods transportation services, offering a
                    wide range of vehicles including Kutty Yaanai (Tata Ace),
                    407, Bolero, and tempo trucks. Serving Coimbatore and
                    Tiruppur, we help businesses and individuals move goods
                    quickly, safely, and cost-effectively. Hello Truck was born
                    to create a platform that connects you with the right trucks
                    at the right price, all with just a few clicks.
                  </p>
                </div>

                <div className="about-counter-box">
                  <div className="about-counter-item">
                    <h2>
                      <span className="counter">91</span>%
                    </h2>
                    <p>Our customer satisfaction rate stands at impressive</p>
                  </div>

                  <div className="about-counter-item">
                    <h2>
                      <span className="counter">2000</span>+
                    </h2>
                    <p>
                      Helping families and businesses to their new destinations
                    </p>
                  </div>
                </div>

                <div
                  className="about-us-btn wow fadeInUp"
                  data-wow-delay="0.4s"
                >
                  <Link to="/about" className="btn-default">
                    more about us
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-lg-12 order-3">
              <div className="about-owner-box">
                <div className="about-owner-info">
                  <div className="about-owner-content wow fadeInUp">
                    <p>
                      "Moving isn't just about transporting items, it's about
                      embracing change and starting fresh. We're dedicated to
                      ensuring your journey is seamless, so you can focus on
                      settling into your new beginning."
                    </p>
                  </div>
                </div>

                <div className="about-owner-image">
                  <figure className="image-anime reveal">
                    <img
                      src="/hellotruck-web-images/about-owner-image.jpg_1785751200307.JPG"
                      alt=""
                    />
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Our Approach Section */}
      <div className="our-approach dark-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="our-approach-image">
                <div className="our-approach-img-box">
                  <div className="our-approach-img-1">
                    <figure className="image-anime reveal">
                      <img
                        src="/hellotruck-web-images/our-approach-image-1.jpg"
                        alt=""
                      />
                    </figure>
                  </div>

                  <div className="trusted-client-box wow fadeInUp">
                    <h3>Trusted by 500+ clients for reliable moves.</h3>
                  </div>
                </div>

                <div className="our-approach-img-box">
                  <div className="our-approach-img-2">
                    <figure className="image-anime reveal">
                      <img
                        src="/hellotruck-web-images/our-approach-image-2.JPG"
                        alt=""
                      />
                    </figure>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="our-approch-content">
                <div className="section-title">
                  <h3 className="wow fadeInUp">our approach</h3>
                  <h2 className="text-anime-style-2" data-cursor="-opaque">
                    Discover the heart of <span>our mission</span>
                  </h2>
                  <p className="wow fadeInUp" data-wow-delay="0.2s">
                    Our mission is to achieve seamless, stress-free moving
                    experiences by providing efficient, affordable and
                    customer-friendly moving services. We believe that every
                    shipment matters, and we're dedicated to ensuring your goods
                    reach their destination on time, every time.
                  </p>
                </div>

                <div className="mission-vision-list">
                  <div
                    className="mission-vision-item wow fadeInUp"
                    data-wow-delay="0.4s"
                  >
                    <div className="icon-box">
                      <img
                        src="/hellotruck-web-images/icon-our-mission.svg"
                        alt=""
                      />
                    </div>
                    <div className="mission-vision-content">
                      <h3>our mission</h3>
                      <p>
                        Our mission is to provide hassle-free, customized moving
                        services with a focus on care and efficiency
                      </p>
                    </div>
                  </div>

                  <div
                    className="mission-vision-item wow fadeInUp"
                    data-wow-delay="0.6s"
                  >
                    <div className="icon-box">
                      <img
                        src="/hellotruck-web-images/icon-our-vision.svg"
                        alt=""
                      />
                    </div>
                    <div className="mission-vision-content">
                      <h3>our vision</h3>
                      <p>
                        Our vision is to redefine the moving experience by
                        prioritizing customer satisfaction and innovative
                        solutions.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Who We Are Section */}
      <div className="who-we-are">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="who-we-are-content">
                <div className="section-title">
                  <h3 className="wow fadeInUp">who we are</h3>
                  <h2 className="text-anime-style-2" data-cursor="-opaque">
                    Redefining Relocation <span>Excellence</span>
                  </h2>
                  <p className="wow fadeInUp" data-wow-delay="0.2s">
                    Our platform is designed to make truck booking as easy as
                    booking a ride. With a wide network of verified truck owners
                    and operators, we offer a range of vehicles to suit your
                    needs. Our dedicated team ensures every detail is managed
                    with care, making your relocation experience smooth and
                    hassle-free.
                  </p>
                </div>

                <div className="who-we-body">
                  <div
                    className="who-we-item wow fadeInUp"
                    data-wow-delay="0.4s"
                  >
                    <div className="icon-box">
                      <img
                        src="/hellotruck-web-images/icon-who-we-are-1.svg"
                        alt=""
                      />
                    </div>
                    <div className="who-we-item-content">
                      <h3>
                        We simplify your move with seamless, efficient services.
                      </h3>
                    </div>
                  </div>

                  <div
                    className="who-we-item wow fadeInUp"
                    data-wow-delay="0.6s"
                  >
                    <div className="icon-box">
                      <img
                        src="/hellotruck-web-images/icon-who-we-are-2.svg"
                        alt=""
                      />
                    </div>
                    <div className="who-we-item-content">
                      <h3>
                        From careful packing to secure delivery, we handle all
                        your needs.
                      </h3>
                    </div>
                  </div>

                  <div
                    className="who-we-item wow fadeInUp"
                    data-wow-delay="0.8s"
                  >
                    <div className="icon-box">
                      <img
                        src="/hellotruck-web-images/icon-who-we-are-3.svg"
                        alt=""
                      />
                    </div>
                    <div className="who-we-item-content">
                      <h3>
                        Our dedicated team ensures safe and reliable
                        transportation services.
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="who-we-are-images">
                <div className="who-we-image-box-1">
                  <div className="who-we-img-1">
                    <figure className="image-anime reveal">
                      <img
                        src="/hellotruck-web-images/hero-bg_1785751057959.JPG"
                        alt=""
                      />
                    </figure>
                  </div>

                  <div className="who-we-img-2">
                    <figure className="image-anime reveal">
                      <img
                        src="/hellotruck-web-images/who-we-are-img-2.jpg"
                        alt=""
                      />
                    </figure>
                  </div>
                </div>

                <div className="who-we-image-box-2">
                  <div className="who-we-img-3">
                    <figure className="image-anime reveal">
                      <img
                        src="/hellotruck-web-images/who-we-are-img-3.jpg"
                        alt=""
                      />
                    </figure>
                  </div>

                  <div className="who-we-img-4">
                    <figure className="image-anime reveal">
                      <img
                        src="/hellotruck-web-images/who-we-are-img-4.jpg"
                        alt=""
                      />
                    </figure>
                  </div>
                </div>

                <div className="contact-us-circle">
                  <Link to="/contact">
                    <img
                      src="/hellotruck-web-images/contact-us-circle-dark.svg"
                      alt=""
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Why Choose Us Section */}
      <div className="why-choose-us dark-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="why-choose-box">
                <div className="why-choose-content">
                  <div className="section-title">
                    <h3 className="wow fadeInUp">why choose us</h3>
                    <h2 className="text-anime-style-2" data-cursor="-opaque">
                      Why we're the preferred choice <span>for moving</span>
                    </h2>
                  </div>

                  <div
                    className="why-choose-body wow fadeInUp"
                    data-wow-delay="0.2s"
                  >
                    <ul>
                      <li>
                        Customer First - Your satisfaction is our priority.
                      </li>
                      <li>Timely service with no hidden fees.</li>
                      <li>Safe, secure transport for your belongings.</li>
                      <li>Customized moving plans to fit your needs.</li>
                      <li>
                        Eco-Friendly Approach, by optimizing routes and reducing
                        empty trips.
                      </li>
                    </ul>
                  </div>
                </div>

                <div
                  className="request-quote-form-box wow fadeInUp"
                  data-wow-delay="0.4s"
                >
                  <h3>request a quote</h3>

                  <div className="request-quote-form">
                    <form id="requestquoteForm" action="#" method="POST">
                      <div className="row">
                        <div className="form-group col-md-6 mb-4">
                          <input
                            type="text"
                            name="name"
                            className="form-control"
                            id="name"
                            placeholder="name"
                            required
                          />
                          <div className="help-block with-errors"></div>
                        </div>

                        <div className="form-group col-md-6 mb-4">
                          <input
                            type="email"
                            name="email"
                            className="form-control"
                            id="email"
                            placeholder="Email"
                            required
                          />
                          <div className="help-block with-errors"></div>
                        </div>

                        <div className="form-group col-md-6 mb-4">
                          <input
                            type="text"
                            name="phone"
                            className="form-control"
                            id="phone"
                            placeholder="Phone"
                            required
                          />
                          <div className="help-block with-errors"></div>
                        </div>

                        <div className="form-group col-md-6 mb-4">
                          <input
                            type="date"
                            name="date"
                            className="form-control"
                            id="date"
                            required
                          />
                          <div className="help-block with-errors"></div>
                        </div>

                        <div className="form-group col-md-6 mb-4">
                          <input
                            type="text"
                            name="PickupLocation"
                            className="form-control"
                            id="pickup-location"
                            placeholder="Pickup location"
                            required
                          />
                          <div className="help-block with-errors"></div>
                        </div>

                        <div className="form-group col-md-6 mb-4">
                          <input
                            type="text"
                            name="DropLocation"
                            className="form-control"
                            id="drop-location"
                            placeholder="Drop location"
                            required
                          />
                          <div className="help-block with-errors"></div>
                        </div>

                        <div className="form-group col-md-12 mb-4">
                          <select
                            name="services"
                            className="form-control form-select"
                            id="services"
                            required
                          >
                            <option value="" disabled selected>
                              service type
                            </option>
                            <option value="residential_moving">
                              Residential Moving
                            </option>
                            <option value="commercial_moving">
                              Commercial Moving
                            </option>
                            <option value="specialty_item">
                              Specialty Item Moving
                            </option>
                            <option value="eco_friendly">
                              Eco-Friendly Moving
                            </option>
                            <option value="office_relocation">
                              Office Relocation
                            </option>
                            <option value="packing_unpacking">
                              Packing & Unpacking
                            </option>
                            <option value="storage_solutions">
                              Storage Solutions
                            </option>
                            <option value="moving_assistance">
                              Moving Assistance
                            </option>
                          </select>
                          <div className="help-block with-errors"></div>
                        </div>

                        <div className="form-group col-md-12">
                          <button type="submit" className="btn-default">
                            contact us now
                          </button>
                          <div id="msgSubmit" className="h3 hidden"></div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Our Success Story Section */}
      <div className="our-success-story">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="success-story-images">
                <div className="success-story-img-1">
                  <figure className="image-anime reveal">
                    <img
                      src="/hellotruck-web-images/success-story-image-1.jpg"
                      alt=""
                    />
                  </figure>
                </div>

                <div className="success-story-img-2">
                  <figure className="image-anime">
                    <img
                      src="/hellotruck-web-images/success-story-image-2.jpg"
                      alt=""
                    />
                  </figure>
                </div>

                <div className="contact-now-box">
                  <div className="icon-box">
                    <img
                      src="/hellotruck-web-images/icon-phone-primary.svg"
                      alt=""
                    />
                  </div>
                  <div className="contact-now-box-content">
                    <h3>call us now</h3>
                    <p>
                      <a href="tel:+917053315331">+91 70 5331 5331</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="success-story-content">
                <div className="section-title">
                  <h3 className="wow fadeInUp">Real Stories, Real Moves</h3>
                  <h2 className="text-anime-style-2" data-cursor="-opaque">
                    Transforming moves into <span>success stories</span>
                  </h2>
                  <p className="wow fadeInUp" data-wow-delay="0.2s">
                    At Hello Truck, we take pride in delivering seamless moving
                    experiences that lead to happy clients. Read the success
                    stories of those who trusted us to handle their relocations
                    with care and efficiency.
                  </p>
                </div>

                <div
                  className="success-story-body wow fadeInUp"
                  data-wow-delay="0.4s"
                >
                  <ul>
                    <li>See how we simplify moves.</li>
                    <li>Effortless moving with experts.</li>
                    <li>Explore our stress moving process.</li>
                    <li>Making relocation simple.</li>
                  </ul>
                </div>

                <div
                  className="success-story-btn wow fadeInUp"
                  data-wow-delay="0.6s"
                >
                  <Link to="/contact" className="btn-default">
                    contact us
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Our Work Process Section */}
      <div className="our-work-process dark-section">
        <div className="container">
          <div className="row section-row">
            <div className="col-lg-12">
              <div className="section-title section-title-center">
                <h3 className="wow fadeInUp">our work process</h3>
                <h2 className="text-anime-style-2" data-cursor="-opaque">
                  Reliable moving services built <span>around you</span>
                </h2>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="wrok-process-list">
              <div className="work-process-item wow fadeInUp">
                <div className="icon-box">
                  <img
                    src="/hellotruck-web-images/icon-work-process-1.svg"
                    alt=""
                  />
                  <div className="work-process-number">
                    <h3>1</h3>
                  </div>
                </div>
                <div className="work-process-content">
                  <h3>get a quote</h3>
                  <p>
                    Start by contacting us for a free, personalized quote. Share
                    your moving details.
                  </p>
                </div>
              </div>

              <div
                className="work-process-item wow fadeInUp"
                data-wow-delay="0.2s"
              >
                <div className="icon-box">
                  <img
                    src="/hellotruck-web-images/icon-work-process-2.svg"
                    alt=""
                  />
                  <div className="work-process-number">
                    <h3>2</h3>
                  </div>
                </div>
                <div className="work-process-content">
                  <h3>plan your move</h3>
                  <p>
                    Our team works with you to create a customized moving plan.
                    From packing to logistics.
                  </p>
                </div>
              </div>

              <div
                className="work-process-item wow fadeInUp"
                data-wow-delay="0.4s"
              >
                <div className="icon-box">
                  <img
                    src="/hellotruck-web-images/icon-work-process-3.svg"
                    alt=""
                  />
                  <div className="work-process-number">
                    <h3>3</h3>
                  </div>
                </div>
                <div className="work-process-content">
                  <h3>safe & secure moving</h3>
                  <p>
                    Our expert movers handle your belongings with care, using
                    high-quality packing materials.
                  </p>
                </div>
              </div>

              <div
                className="work-process-item wow fadeInUp"
                data-wow-delay="0.6s"
              >
                <div className="icon-box">
                  <img
                    src="/hellotruck-web-images/icon-work-process-4.svg"
                    alt=""
                  />
                  <div className="work-process-number">
                    <h3>4</h3>
                  </div>
                </div>
                <div className="work-process-content">
                  <h3>unpack & settle in</h3>
                  <p>
                    Once we've delivered your items, we'll help with unpacking
                    and setting up, so you can enjoy.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* What We DO Section */}
      <div className="what-we-do">
        <div className="container">
          <div className="row what-we-do-box no-gutters">
            <div className="col-lg-4">
              <div className="what-we-do-image">
                <figure className="image-anime reveal">
                  <img
                    src="/hellotruck-web-images/what-we-do-image.jpg"
                    alt=""
                  />
                </figure>
              </div>
            </div>

            <div className="col-lg-8">
              <div className="what-we-content">
                <div className="section-title">
                  <h3 className="wow fadeInUp">what we do</h3>
                  <h2 className="text-anime-style-2" data-cursor="-opaque">
                    Get premium our <span>services</span>
                  </h2>
                  <p className="wow fadeInUp" data-wow-delay="0.2s">
                    Discover top-notch services designed to meet your needs with
                    excellence. From tailored solutions to expert support, we
                    ensure a seamless and satisfying experience every step of
                    the way.
                  </p>
                </div>

                <div className="what-we-body">
                  <div
                    className="what-we-item wow fadeInUp"
                    data-wow-delay="0.4s"
                  >
                    <div className="icon-box">
                      <img
                        src="/hellotruck-web-images/icon-what-we-1.svg"
                        alt=""
                      />
                    </div>
                    <div className="what-we-item-content">
                      <h3>regular full services</h3>
                      <p>
                        Our services cover every aspect of your need ensuring
                        seamless.
                      </p>
                    </div>
                  </div>

                  <div
                    className="what-we-item wow fadeInUp"
                    data-wow-delay="0.6s"
                  >
                    <div className="icon-box">
                      <img
                        src="/hellotruck-web-images/icon-what-we-2.svg"
                        alt=""
                      />
                    </div>
                    <div className="what-we-item-content">
                      <h3>on-demand</h3>
                      <p>
                        encompassing regular inspections and preventative
                        measures
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div className="what-we-counter-list">
                <div className="what-we-counter-item">
                  <h2>
                    <span className="counter">500</span>+
                  </h2>
                  <p>Residential shifts</p>
                </div>

                <div className="what-we-counter-item">
                  <h2>
                    <span className="counter">2000</span>+
                  </h2>
                  <p>Industrial shifts</p>
                </div>

                <div className="what-we-counter-item">
                  <h2>
                    <span className="counter">500</span>%
                  </h2>
                  <p>regular local deliveries</p>
                </div>

                <div className="what-we-counter-item">
                  <h2>
                    <span className="counter">150</span>+
                  </h2>
                  <p>regular inter-city services</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Our Testimonials Section */}
      <div className="our-testimonials">
        <div className="container">
          <div className="row section-row">
            <div className="col-lg-12">
              <div className="section-title section-title-center">
                <h3 className="wow fadeInUp">testimonials</h3>
                <h2 className="text-anime-style-2" data-cursor="-opaque">
                  Words of appreciation from <span>our customers</span>
                </h2>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div className="testimonial-slider">
                <div className="swiper">
                  <div className="swiper-wrapper" data-cursor-text="Drag">
                    <div className="swiper-slide">
                      <div className="testimonial-item">
                        <div className="author-image">
                          <figure className="image-anime">
                            <img
                              src="/hellotruck-web-images/author-1.jpg"
                              alt=""
                            />
                          </figure>
                        </div>

                        <div className="author-content">
                          <div className="author-title">
                            <h3>Ravi, Gandhipuram</h3>
                          </div>
                          <div className="author-rating">
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                          </div>
                        </div>

                        <div className="testimonial-content">
                          <p>
                            From the first phone call to the final box,
                            everything was seamless. The movers were friendly,
                            efficient, and went above and beyond to make sure my
                            furniture arrived safely. Amazing experience!
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="swiper-slide">
                      <div className="testimonial-item">
                        <div className="author-image">
                          <figure className="image-anime">
                            <img
                              src="/hellotruck-web-images/author-2.jpg"
                              alt=""
                            />
                          </figure>
                        </div>

                        <div className="author-content">
                          <div className="author-title">
                            <h3>Arunkumar, Singanallur</h3>
                          </div>
                          <div className="author-rating">
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                          </div>
                        </div>

                        <div className="testimonial-content">
                          <p>
                            From the first phone call to the final box,
                            everything was seamless. The movers were friendly,
                            efficient, and went above and beyond to make sure my
                            furniture arrived safely. Amazing experience!
                          </p>
                        </div>
                      </div>
                    </div>

                    <div className="swiper-slide">
                      <div className="testimonial-item">
                        <div className="author-image">
                          <figure className="image-anime">
                            <img
                              src="/hellotruck-web-images/author-3.jpg"
                              alt=""
                            />
                          </figure>
                        </div>

                        <div className="author-content">
                          <div className="author-title">
                            <h3>Kannan, Thudiyalur</h3>
                          </div>
                          <div className="author-rating">
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                            <i className="fa-solid fa-star"></i>
                          </div>
                        </div>

                        <div className="testimonial-content">
                          <p>
                            From the first phone call to the final box,
                            everything was seamless. The movers were friendly,
                            efficient, and went above and beyond to make sure my
                            furniture arrived safely. Amazing experience!
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="testimonial-btn">
                    <div className="testimonial-btn-prev"></div>
                    <div className="testimonial-btn-next"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Our Faqs Section */}
      <div className="our-faqs">
        <div className="container-fluid">
          <div className="row no-gutters">
            <div className="col-lg-6">
              <div className="faq-content-box">
                <div className="our-faqs-content">
                  <div className="section-title section-title-center">
                    <h3 className="wow fadeInUp">frequently asked questions</h3>
                    <h2 className="text-anime-style-2" data-cursor="-opaque">
                      Answers to your <span>moving questions</span>
                    </h2>
                  </div>

                  <div className="faq-accordion" id="faqaccordion">
                    <div className="accordion-item wow fadeInUp">
                      <h2 className="accordion-header" id="heading1">
                        <button
                          className="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse1"
                          aria-expanded="true"
                          aria-controls="collapse1"
                        >
                          How far in advance should I book my move?
                        </button>
                      </h2>
                      <div
                        id="collapse1"
                        className="accordion-collapse collapse show"
                        aria-labelledby="heading1"
                        data-bs-parent="#faqaccordion"
                      >
                        <div className="accordion-body">
                          <p>
                            We recommend booking your move at least 2-4 weeks in
                            advance to ensure availability, especially during
                            peak seasons.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div
                      className="accordion-item wow fadeInUp"
                      data-wow-delay="0.2s"
                    >
                      <h2 className="accordion-header" id="heading2">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse2"
                          aria-expanded="false"
                          aria-controls="collapse2"
                        >
                          Do you provide packing materials?
                        </button>
                      </h2>
                      <div
                        id="collapse2"
                        className="accordion-collapse collapse"
                        aria-labelledby="heading2"
                        data-bs-parent="#faqaccordion"
                      >
                        <div className="accordion-body">
                          <p>
                            We recommend booking your move at least 2-4 weeks in
                            advance to ensure availability, especially during
                            peak seasons.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div
                      className="accordion-item wow fadeInUp"
                      data-wow-delay="0.4s"
                    >
                      <h2 className="accordion-header" id="heading3">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse3"
                          aria-expanded="false"
                          aria-controls="collapse3"
                        >
                          Are my belongings insured during the move?
                        </button>
                      </h2>
                      <div
                        id="collapse3"
                        className="accordion-collapse collapse"
                        aria-labelledby="heading3"
                        data-bs-parent="#faqaccordion"
                      >
                        <div className="accordion-body">
                          <p>
                            We recommend booking your move at least 2-4 weeks in
                            advance to ensure availability, especially during
                            peak seasons.
                          </p>
                        </div>
                      </div>
                    </div>

                    <div
                      className="accordion-item wow fadeInUp"
                      data-wow-delay="0.6s"
                    >
                      <h2 className="accordion-header" id="heading4">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapse4"
                          aria-expanded="false"
                          aria-controls="collapse4"
                        >
                          Do you offer long-distance moving services?
                        </button>
                      </h2>
                      <div
                        id="collapse4"
                        className="accordion-collapse collapse"
                        aria-labelledby="heading4"
                        data-bs-parent="#faqaccordion"
                      >
                        <div className="accordion-body">
                          <p>
                            We recommend booking your move at least 2-4 weeks in
                            advance to ensure availability, especially during
                            peak seasons.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="faqs-image">
                <div className="faq-image">
                  <figure className="image-anime">
                    <img src="/hellotruck-web-images/faq-image.jpg" alt="" />
                  </figure>
                </div>

                <div className="intro-video-button">
                  <a
                    href="/hellotruck-web-images/hello_truck_video.mp4"
                    className="popup-video"
                    data-cursor-text="Play"
                  >
                    <figure>
                      <img
                        src="/hellotruck-web-images/intro-video-circle.svg"
                        alt=""
                      />
                    </figure>

                    <div className="into-video-play-icon">
                      <img
                        src="/hellotruck-web-images/intro-video-play-btn.svg"
                        alt=""
                      />
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
